import { render, staticRenderFns } from "./ListActionButtons.vue?vue&type=template&id=f6047b24&"
import script from "./ListActionButtons.vue?vue&type=script&lang=js&"
export * from "./ListActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports